function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15.147 3.056C14.537.854 12.7.076 12.623.044a.58.58 0 00-.442 1.073c.013.006 1.387.589 1.848 2.25a.58.58 0 001.118-.31zM3.303.36a.58.58 0 00-.757-.316C2.468.076.632.854.02 3.057a.58.58 0 001.119.31c.453-1.636 1.787-2.224 1.85-2.25A.58.58 0 003.303.36zM13.866 15.018l-1.316-1.374a.58.58 0 10-.839.803l1.316 1.374a.58.58 0 10.839-.803zM3.44 13.627a.58.58 0 00-.821.017l-1.316 1.374a.58.58 0 00.838.803l1.316-1.374a.58.58 0 00-.018-.82zM9.751 7.313h-1.8V4.546a.58.58 0 10-1.16 0v3.347c0 .321.26.58.58.58h2.38a.58.58 0 100-1.16z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.584.793a6.799 6.799 0 00-6.79 6.79 6.799 6.799 0 006.79 6.792 6.799 6.799 0 006.79-6.791 6.799 6.799 0 00-6.79-6.79zm0 12.421a5.636 5.636 0 01-5.63-5.63 5.636 5.636 0 015.63-5.63 5.636 5.636 0 015.63 5.63 5.636 5.636 0 01-5.63 5.63z"
});

function SvgAlarm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props), _ref, _ref2);
}

export default SvgAlarm;


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/alarm.svg
// module id = 1283
// module chunks = 10